import React from "react";

const SellingOrder = (props: any) => {
  const { sellingProducts, currentProductQuantity } = props;

  return (
    <>
      {Object.values(sellingProducts)?.filter(
        (item: any) => item.selectedQuantity > 0
      ).length > 0 && (
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Product</th>
              <th>Qty</th>
              <th>Price</th>
            </tr>
          </thead>
        )}
      <tbody>
        {Object.values(sellingProducts)?.map((item: any, index: number) => {
          if (item?.selectedQuantity === 0) {
            return null;
          }
          return (
            <tr key={item?.id}>
              <td>{index + 1}</td>
              <td className="text-nowrap">{item.name}</td>
              <td className="text-nowrap">
                {currentProductQuantity?.[item?.id]}
              </td>
              <td className="text-nowrap">
                <span className="rupees-symbol">&#8377;</span>{" "}
                {(item.selectedQuantity * item.sellingPrice)?.toFixed(2)}
              </td>
            </tr>
          );
        })}
      </tbody>
    </>
  );
};
export { SellingOrder };
